import { Reducer } from 'redux'
import produce from 'immer'
import { isEqual } from 'libraries/lodash'

import { RESPONSE_PENDING } from 'libraries/front-end-core/constants/responses'
import {
  SET_ACCORDION_EXPANDED_NODE_ID,
  SET_ACCORDION_EXPANDED_NODE_TITLE,
  SET_ACCORDION_HIGHLIGHT,
  SET_ACCORDION_GROUP,
  SET_ACCORDION_EVENT_CATEGORY,
  SET_ACCORDION_HAS_EXPAND_CALLBACK,
  SET_ACCORDION_BREADCRUMB_CLICKED,
  SET_ACCORDION_URL_NODE,
  SET_ACCORDION_SECTION_ID,
  SET_ACCORDION_TEXT_FRAGMENT
} from 'redux/actions/types'
import { AccordionGroup, TextFragment } from 'interfaces/accordion'

export interface AccordionState {
  expandedNodeId: string | null
  expandedNodeTitle: string | null
  highlight: string | null
  group: number | AccordionGroup[]
  eventCategory: string
  hasExpandCallback: boolean
  breadCrumbClicked: boolean
  sectionId: string | null
  urlNode: string | null
  textFragment: TextFragment | null
}

const initialState: AccordionState = {
  expandedNodeId: null,
  expandedNodeTitle: null,
  highlight: null,
  group: RESPONSE_PENDING,
  eventCategory: 'Accordion',
  hasExpandCallback: false,
  breadCrumbClicked: false,
  sectionId: null,
  urlNode: null,
  textFragment: null
}

const accordion: Reducer<AccordionState, any> = (state = initialState, action) => { // FIX me remove AnyAction
  switch (action.type) {
    case SET_ACCORDION_EXPANDED_NODE_ID:
      return produce(state, draft => {
        draft.expandedNodeId = action.expandedNodeId
      })
    case SET_ACCORDION_EXPANDED_NODE_TITLE:
      return produce(state, draft => {
        draft.expandedNodeTitle = action.expandedNodeTitle
      })
    case SET_ACCORDION_HIGHLIGHT:
      return produce(state, draft => {
        draft.highlight = action.highlight
      })
    case SET_ACCORDION_GROUP:
      return produce(state, draft => {
        draft.group = action.group
      })
    case SET_ACCORDION_EVENT_CATEGORY:
      return produce(state, draft => {
        draft.eventCategory = action.eventCategory
      })
    case SET_ACCORDION_HAS_EXPAND_CALLBACK:
      return produce(state, draft => {
        draft.hasExpandCallback = action.hasExpandCallback
      })
    case SET_ACCORDION_BREADCRUMB_CLICKED:
      return produce(state, draft => {
        draft.breadCrumbClicked = action.breadCrumbClicked
      })
    case SET_ACCORDION_SECTION_ID:
      return produce(state, draft => {
        draft.sectionId = action.sectionId
      })
    case SET_ACCORDION_URL_NODE:
      return produce(state, draft => {
        draft.urlNode = action.urlNode
      })
    case SET_ACCORDION_TEXT_FRAGMENT:
      // keep the existing reference for an equal value so consumers keyed on it don't re-run
      if (isEqual(state.textFragment, action.textFragment)) return state
      return produce(state, draft => {
        draft.textFragment = action.textFragment
      })
    default:
      return state
  }
}

export default accordion
